import { createFileRoute } from '@tanstack/react-router'
import { ToolsManager } from '../../../../components/ToolsManager'

export const Route = createFileRoute('/desa/$slug/dashboard/tools')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <ToolsManager desaId={desaId} />
  },
})
